<template>
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 26.75C5.16751 26.75 1.25 22.8325 1.25 18V10C1.25 5.16751 5.16751 1.25 10 1.25H18C22.8325 1.25 26.75 5.16751 26.75 10V18C26.75 22.8325 22.8325 26.75 18 26.75H10Z"
      fill="white"
      stroke="#6F8693"
      stroke-width="1.5"
    />
  </svg>
</template>

<script>
export default {
  name: 'CheckboxOff'
};
</script>

<style scoped>

</style>
